import { MenuButton, MenuProps } from '@pega/cosmos-react-core';
import React from 'react';
import useLocalTranslation from '../../../../hooks/useLocalTranslation';
import { ActionsPopoverFlow } from '../../../../constants/common';

interface ActionPopoverProps {
  flow: ActionsPopoverFlow;
  scenario: any;
  handleEditScenario: (arg1: any) => void;
  deleteConfirmation: (arg1: string, arg2: string) => void;
  simulationStatus?: string;
}

const ActionsPopover: React.FC<ActionPopoverProps> = ({
  flow,
  scenario,
  handleEditScenario,
  deleteConfirmation,
  simulationStatus,
}) => {
  const translate = useLocalTranslation();
  const handleEditClick = () => {
    handleEditScenario(scenario);
  };

  const handleDeleteScenario = () => {
    switch (flow) {
      case ActionsPopoverFlow.Feedback:
        deleteConfirmation(scenario?.id, scenario?.name);
        break;
      case ActionsPopoverFlow.FeedbackWebhook:
        deleteConfirmation(scenario?.id, scenario?.webhook);
        break;
      case ActionsPopoverFlow.Scenario:
        deleteConfirmation(scenario?.taskId, scenario?.simulationScenario);
        break;
      case ActionsPopoverFlow.Persona:
        deleteConfirmation(scenario?.customerId, scenario?.bio?.full_name);
    }
  };

  const handleMenuItemClick = (id: string) => {
    switch (id) {
      case 'edit_scenario':
        handleEditClick();
        break;
      case 'delete_scenario':
        handleDeleteScenario();
    }
  };

  const itemsToRender = [
    {
      id: 'edit_scenario',
      primary: translate('edit'),
    },
    {
      id: 'delete_scenario',
      primary: translate('delete'),
    },
  ];

  return (
    <MenuButton
      text={translate('actions_items_button')}
      icon="more"
      iconOnly
      data-testid="menu"
      variant="simple"
      disabled={simulationStatus === 'start'}
      menu={
        {
          items: itemsToRender,
          onItemClick: handleMenuItemClick,
        } as MenuProps
      }
    />
  );
};

export default ActionsPopover;
